import { AMBER, BLUE, RED } from '@swegon-core/uic/dist/src/theme';
import { CircleCheckmark } from '../theme/icons/CircleCheckmark';
import {
    ComponentInfo,
    TableCellHeader,
    TableHeader,
    WarningDescription,
    WarningIcon,
    WarningsAndErrorsTable,
    WarningsRow
} from './WarningsAndErrors.styles';
import { CircleCrossmark } from '../theme/icons/CircleCrossmark';
import { CircleMinus } from '../theme/icons/CircleMinus';
import {
    SeverityLevel,
    CalculationWarning,
    SEVERITY_LEVEL
} from '../shared/components/calculation/CalculationResult.types';
import { useContext } from 'react';
import { Context as TranslationContext } from '../shared/contexts/TranslationContext';
export interface Warning {
    severityLevel: SeverityLevel;
    component: string;
    information: string;
}

export interface WarningsAndErrorsProps {
    warnings: CalculationWarning[];
}

export const WarningsAndErrors = (props: WarningsAndErrorsProps) => {
    const { warnings } = props;
    const { l } = useContext(TranslationContext);

    const getIconForSeverityLevel = (
        severityLevel: SeverityLevel,
        index: number
    ) => {
        switch (severityLevel) {
            case SEVERITY_LEVEL.ERROR:
                return (
                    <CircleCrossmark
                        key={`row-icon${index}`}
                        width={20}
                        height={20}
                        color={RED}
                    />
                );
            case SEVERITY_LEVEL.WARNING:
                return (
                    <CircleCheckmark
                        key={`row-icon${index}`}
                        width={20}
                        height={20}
                        color={AMBER}
                    />
                );
            case SEVERITY_LEVEL.INFORMATION:
                return (
                    <CircleMinus
                        key={`row-icon${index}`}
                        width={20}
                        height={20}
                        color={BLUE}
                    />
                );
            default:
                return (
                    <CircleMinus
                        key={`row-icon${index}`}
                        width={20}
                        height={20}
                        color={BLUE}
                    />
                );
        }
    };

    return (
        <>
            <WarningsAndErrorsTable>
                <TableHeader>
                    <tr>
                        <TableCellHeader key={`header-1`} />
                        <TableCellHeader key={`header-2`}>
                            {l('ahuDesign.component')}
                        </TableCellHeader>
                        <TableCellHeader key={`header-3`}>
                            {l('common.info')}
                        </TableCellHeader>
                    </tr>
                </TableHeader>
                <tbody>
                    {warnings.map((warning: CalculationWarning) => {
                        const index = warnings.indexOf(warning);
                        return (
                            <WarningsRow key={`row-line-${index}`}>
                                <WarningIcon key={`row-icon-cell-${index}`}>
                                    {getIconForSeverityLevel(
                                        warning.severityLevel as SeverityLevel,
                                        index
                                    )}
                                </WarningIcon>
                                <ComponentInfo
                                    key={`row-component-${index}`}
                                    severitylevel={
                                        warning.severityLevel as SeverityLevel
                                    }
                                >
                                    {warning.component}
                                </ComponentInfo>
                                <WarningDescription
                                    key={`row-information-${index}`}
                                >
                                    {warning.information}
                                </WarningDescription>
                            </WarningsRow>
                        );
                    })}
                </tbody>
            </WarningsAndErrorsTable>
        </>
    );
};
